module.exports = __webpack_public_path__ + "static/001_body-landscape-9dd2caefea19b67dcb0d0f937e0571c6.mp4";